import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { useInView } from 'react-intersection-observer';

var Image = function Image(_ref) {
  var alt = _ref.alt,
      firstPaintSource = _ref.firstPaintSource,
      height = _ref.height,
      _ref$isLazyLoaded = _ref.isLazyLoaded,
      isLazyLoaded = _ref$isLazyLoaded === void 0 ? true : _ref$isLazyLoaded,
      sizes = _ref.sizes,
      src = _ref.src,
      srcSet = _ref.srcSet,
      width = _ref.width,
      observerOptions = _ref.observerOptions,
      rest = _objectWithoutProperties(_ref, ["alt", "firstPaintSource", "height", "isLazyLoaded", "sizes", "src", "srcSet", "width", "observerOptions"]);

  var DefaultImage = function DefaultImage() {
    return /*#__PURE__*/React.createElement("img", _extends({
      alt: alt,
      height: height,
      sizes: sizes,
      src: src,
      srcSet: srcSet,
      width: width
    }, rest));
  };

  if (!isLazyLoaded) {
    return /*#__PURE__*/React.createElement(DefaultImage, null);
  }

  var defaultObserverOptions = {
    root: null,
    rootMargin: '250px 0px',
    threshold: 0,
    triggerOnce: true
  };

  var mergedOptions = _objectSpread(_objectSpread({}, defaultObserverOptions), observerOptions);

  var _useInView = useInView(mergedOptions),
      _useInView2 = _slicedToArray(_useInView, 2),
      ref = _useInView2[0],
      inView = _useInView2[1];

  var sourceProperties = inView ? {
    'data-src': undefined,
    src: src
  } : {
    'data-src': src,
    src: firstPaintSource || undefined
  };
  return /*#__PURE__*/React.createElement("img", _extends({
    alt: alt,
    height: height,
    ref: ref,
    sizes: sizes,
    srcSet: srcSet,
    width: width
  }, rest, sourceProperties));
};

export { Image };